import { createAction } from '@reduxjs/toolkit';

export const resetAllSlice = createAction('reset-all-slices');
